/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\hostacquisition.genclient.json
 */

export interface Geography {
    /**
     * The number of hosts that are readily available for host creation in this region on this service instance
     */
    availableHostsCount: number;
    /**
     * Code identifier for the geography.
     */
    code: string;
    /**
     * Display name for the geography.
     */
    displayName: string;
    /**
     * The geography status
     */
    isActive: boolean;
    /**
     * The identifier of the service instances that support host creations in this geography.
     */
    serviceInstanceIds: string[];
}

export interface NameAvailability {
    /**
     * True if the name is available; False otherwise. See the unavailability reason for an explanation.
     */
    isAvailable: boolean;
    /**
     * Name requested.
     */
    name: string;
    /**
     * The reason why IsAvailable is False or Null
     */
    unavailabilityReason: string;
}

export interface Region {
    /**
     * Display name for the region.
     */
    displayName: string;
    /**
     * Code of the Azure geography related to the region.
     */
    geographyCode: string;
    /**
     * Name of the Azure geography related to the region.
     */
    geographyName: string;
    /**
     * Whether the region is default or not
     */
    isDefault: boolean;
    /**
     * Name identifier for the region.
     */
    name: string;
    /**
     * Short name used in Microsoft Azure. Ex: southcentralus, westcentralus, southindia, etc.
     */
    nameInAzure: string;
}
